import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Link, useNavigate, useLocation } from "react-router-dom";
import '../../index.css';
import { ChangePasswordScheme } from '../Components/Schemes/ChangePasswordScheme';
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import { toast, ToastContainer } from 'react-toastify';
import secureLocalStorage from 'react-secure-storage';
import { Puff } from 'react-loader-spinner';
import Routes from '../Components/data/remote/Routes';



const notify = (message, type) => {
    // alert('error', +message)
    type == "success" ? toast.success(message, {

        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        closeButton: false,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",

    })
        :
        toast.error(message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            closeButton: false,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",

            style: {
                backgroundColor: '#D92533'
            }
        });
}


const ChangePassword = () => {

    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
    const toggleConfirmPasswordVisibility = () => {
        setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
    };
    const notify = (message, type) => {
        type == "success" ? toast.success(message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored"
        })
            :
            toast.error(message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored'
            });
    }
    const initialValues = {
        currentPassword: "",
        password: "",
        confirm_password: ""

    };


    const accessToken = secureLocalStorage.getItem('token')

    const history = useNavigate();
    useEffect(() => {
        if (!accessToken) {
            history("/");
        }
    }, [])


    const { values, handleBlur, handleChange, handleSubmit, errors, touched } =
        useFormik({
            initialValues,
            validationSchema: ChangePasswordScheme,
            validateOnChange: true,
            validateOnBlur: false,
            //// By disabling validation onChange and onBlur formik will validate on submit.
            onSubmit: (values, action) => {
                setLoading(true);

                var myHeaders = new Headers();
                myHeaders.append("Authorization", "Bearer " + accessToken);
                var formdata = new FormData();
                formdata.append("current_password", values.currentPassword);
                formdata.append("password", values.password);
                formdata.append("password_confirmation", values.password);

                var requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: formdata,
                    redirect: 'follow'
                };

                fetch(Routes.CHANGEPASSWORD, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        // console.log(result)
                        if (result.message == "Password changed successfully.") {
                            history("/createimr");
                            notify(result.message, "success");
                            setLoading(false);

                        } else {
                            notify(result.message, "error");
                            setLoading(false);

                        }

                    })
                    .catch(error => {
                        console.log('error', error)
                        setLoading(false);

                    });
            },
        });
    return (
        <div className="">
            <ToastContainer
            />
            {loading &&
                <div className="loaderScreen">
                    <Puff
                        height={80}
                        width={80}
                        color="rgba(0, 120, 207, 1)"
                        ariaLabel="puff-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                    />
                </div>
            }
            <Header />
            <div className="inner-image-header-ChangePassword">
                <div className="inner-image-ChangePassword">
                    <p>
                        Change<strong> Password</strong>
                    </p>
                </div>
            </div>

            <div style={{ marginBottom: '83px' }}>
                <form onSubmit={handleSubmit} className="card-body" noValidate>

                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <div className='ChangePasswordInputs login-text-area mt-3'>
                                    <label for="validationDefaultEmail" className="form-label">
                                        <strong className="changePassword-text">Current Password</strong>
                                    </label>
                                    <input
                                        type={isPasswordVisible ? "text" : "password"}
                                        className="form-control changePasswordInput"
                                        id="exampleFormControlInput1"
                                        name="currentPassword"
                                        placeholder="Current Password"
                                        value={values.currentPassword}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {/* <div className="eyeButton" onClick={togglePasswordVisibility}>
                                        {isPasswordVisible ? (
                                            <img width={20} src={showEye} />
                                        ) : (
                                            <img width={20} src={hideEye} />
                                        )}
                                    </div> */}
                                    {errors.currentPassword && touched.currentPassword ? (
                                        <p className="form-error">{errors.currentPassword}</p>
                                    ) : null}
                                </div>

                                <div className='forgetInputs login-text-area mt-3'>
                                    <label for="validationDefaultEmail" className="form-label">
                                        <strong className="changePassword-text">New Password </strong>
                                    </label>
                                    <input
                                        type={isPasswordVisible ? "text" : "password"}
                                        className="form-control changePasswordInput"
                                        id="exampleFormControlInput1"
                                        name="password"
                                        placeholder="New Password"
                                        value={values.password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {/* <div className="eyeButton" onClick={togglePasswordVisibility}>
                                        {isPasswordVisible ? (
                                            <img width={20} src={showEye} />
                                        ) : (
                                            <img width={20} src={hideEye} />
                                        )}
                                    </div> */}
                                    {errors.password && touched.password ? (
                                        <p className="form-error">{errors.password}</p>
                                    ) : null}
                                </div>

                                <div className='forgetInputs login-text-area mt-3'>
                                    <label for="validationDefaultEmail" className="form-label">
                                        <strong className="changePassword-text">Confirm New Password</strong>
                                    </label>
                                    <input
                                        type={isConfirmPasswordVisible ? "text" : "password"}
                                        className="form-control changePasswordInput"
                                        id="exampleFormControlInput1"
                                        name="confirm_password"
                                        placeholder="Confirm New Password"
                                        value={values.confirm_password}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {/* <div className="eyeButton" onClick={toggleConfirmPasswordVisibility}>
                                        {isConfirmPasswordVisible ? (
                                            <img width={20} src={showEye} />
                                        ) : (
                                            <img width={20} src={hideEye} />
                                        )}
                                    </div> */}
                                    {errors.confirm_password && touched.confirm_password ? (
                                        <p className="form-error">{errors.confirm_password}</p>
                                    ) : null}
                                </div>
                                <button className="changePassword-button mt-4" type="submit">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <Footer />
        </div>
    );
};

export default ChangePassword;
